/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpTextField,
  CmpButton,
  CmpTextFieldEnter,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fcovertToNumber } from "../../Utility/Utilitys";
import InstantPicking_Breadcrumbs from "./instantPicking_BreadCrumbs";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { InstantPickingHead_Status_Set } from "./SliceInstantPickingHead";
import "./instantpicking.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
export default function InstantPickingDetail() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const BarcodeFocusOnLoad = useRef(null);
  const vRdxInstantPickingDetail = useSelector(
    (state) => state.SliceInstantPickingHead.value.InstantPickingHead
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const columns = [
    {
      field: "SrNo",
      headerName: "Sr No",
      width: 50,
    },
    {
      field: "ItemCode",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 320,
    },
    // {
    //     field: 'picked',
    //     headerName: 'Picked',
    //     width: 80,
    // },
    {
      field: "Barcode",
      headerName: "Bar Code",
      width: 100,
      hide: true,
    },
    {
      field: "BinCd",
      headerName: "Bar Cd",
      width: 100,
      hide: true,
    },
    {
      field: "BinName",
      headerName: "Bin",
      width: 130,
    },
    {
      field: "CardId",
      headerName: "Card Id",
      width: 130,
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "UnitCode",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "BaseQty",
      headerName: "Base Qty",
      width: 100,
    },
  ];
  const VarianceColumns = [
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 120,
    },
    {
      field: "Name1",
      headerName: "Item Name",
      width: 250,
    },
    // {
    //     field: 'picked',
    //     headerName: 'Picked',
    //     width: 80,
    // },
    {
      field: "INVQty",
      headerName: "Invoice Qty",
      width: 100,
    },
    {
      field: "PickedQty",
      headerName: "Picked Qty",
      width: 100,
    },
    {
      field: "Difference",
      headerName: "Difference",
      width: 100,
    },
  ];
  const [inputGridData, setInputGridData] = useState([]);
  const [sVarianceList, setVarianceList] = useState([]);

  const itemRows = inputGridData?.map((obj, i) => ({ ...obj, id: i + 1 }));
  const vVarianceRows = sVarianceList?.map((obj, i) => ({ ...obj, id: i + 1 }));
  const sEnterKeyObj = {
    key: "Enter",
  };

  const [sLoading, setLoading] = useState(false);
  const vInitialstate = {
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Barcode: "",
    Status: vRdxInstantPickingDetail.Status,
    CardId: "",
    Qty: 0,
    BaseQty: 0,
    Invoiced: "",
    Picked: "",
    Balance: "",
    Unit: "",
    PackQty: "",
    Stock: "",
  };
  const [sDetail, setDetail] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Barcode: "",
    Status: vRdxInstantPickingDetail.Status,
    // BinCd: "",
    // BinName: "",
    CardId: "",
    Qty: 0,
    // UnitCode: "",
    // UnitName: "",
    BaseQty: 0,
    Invoiced: "",
    Picked: "",
    Balance: "",
    Unit: "",
    PackQty: "",
    Stock: "",
  });

  const [sUnitData, setUnitDataArr] = useState([]);
  const [sBinStock, setBinStock] = useState(0);
  const vInitError = {
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    Barcode: "",
    CardId: "",
    Qty: "",
    BaseQty: "",
    Invoiced: "",
    Picked: "",
    Balance: "",
    Unit: "",
    PackQty: "",
    Stock: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    Barcode: "",
    CardId: "",
    Qty: "",
    BaseQty: "",
    Invoiced: "",
    Picked: "",
    Balance: "",
    Unit: "",
    PackQty: "",
    Stock: "",
  });

  const [
    sOpenInstantPickingPostVarianceModel,
    setOpenInstantPickingVarianceModel,
  ] = useState(false);
  const [sOpenInstantPickingModel, setOpenInstantPickingModel] =
    useState(false);

  const fCloseInstantPickingModel = () => {
    setOpenInstantPickingModel(false);
  };

  const fOpenInstantPickingModel = () => {
    setOpenInstantPickingModel(true);
  };
  const fCloseInstantPickingVarianceModel = () => {
    setOpenInstantPickingVarianceModel(false);
  };

  const fOpenInstantPickingVarianceModel = () => {
    setOpenInstantPickingVarianceModel(true);
  };

  const fonDoubleClickCloseGrid = (e) => {
    setOpenInstantPickingModel(false);
  };
  const fCardIdKey = (e) => {
    // alert(e.keyCode);
    // setDetail((obj) => ({ ...obj, Barcode: e.target.value, }));
    if (
      e.key === "Enter" ||
      e.key === "Tab" ||
      e.keyCode === 13 ||
      e.keyCode === 9
    ) {
      GetCartBarcodeDetail();
    } else if (e.key === "Backspace" || e.keyCode === 8) {
      setDetail((obj) => ({
        ...obj,
        ItemName: "",
        ItemCode: "",
        CardId: "",
        Invoiced: "",
        Picked: "",
        Unit: "",
      }));
      setUnitDataArr([]);
    } else if (e.key === "Delete" || e.keyCode === 46) {
      if (sDetail.CardId == "") {
        setDetail((obj) => ({
          ...obj,
          ItemName: "",
          ItemCode: "",
          CardId: "",
          Invoiced: "",
          Picked: "",
          Unit: "",
        }));
      }
    }
  };
  const fQtyKey = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      if (sDetail.Qty !== "") {
        fSave();
      }
    }
  };
  const fOnChangeInstantPickingDetail = useCallback(
    (e) => {
      if (e.target.name === "Barcode" || e.target.name === "Qty") {
        if (e.target.value >= 0 || e.target.value === "") {
          setDetail((obj) => ({
            ...obj,
            [e.target.name]: e.target.value,
          }));
        }
      } else {
        setDetail((obj) => ({
          ...obj,
          [e.target.name]: e.target.value,
        }));
      }

      //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
      if (
        e.target.value.length < sDetail.Barcode.toString().length &&
        vMediaQuery &&
        e.target.name === "Barcode"
      ) {
        var vBackSpaceObj = {
          key: "Backspace",
        };
        if (e.target.value !== "" && vMediaQuery) {
          fCardIdKey(vBackSpaceObj);
        }
      }
    },
    [sDetail]
  );

  const fUnitSelect = useCallback(
    (e) => {
      var vUnit = sUnitData.find((obj) => {
        return obj.Unit == e.target.value;
      });

      setDetail((obj) => ({
        ...obj,
        Unit: vUnit.Unit,
        PackQty: vUnit.PackQty,
      }));
      // setPackQty(vUnit.PackQty);
    },
    [sDetail]
  );

  const setValidation = () => {
    let iRes = true;
    if (sDetail.CardId === "") {
      setErrorMsg((obj) => ({ ...obj, CardId: "cardId is Empty" }));
      iRes = false;
    }
    if (sDetail.Barcode === "") {
      setErrorMsg((obj) => ({ ...obj, Barcode: "Barcode is Empty" }));
      iRes = false;
    }
    if (sDetail.Invoiced === "") {
      setErrorMsg((obj) => ({ ...obj, Invoiced: "Invoiced is Empty" }));
      iRes = false;
    } else if (sDetail.Invoiced === 0) {
      setErrorMsg((obj) => ({ ...obj, Invoiced: "invoice shouldn't be zero" }));
      iRes = false;
    }
    if (vRdxInstantPickingDetail.BinCode === "") {
      setErrorMsg((obj) => ({ ...obj, BinCode: "BinCode is Empty" }));
      iRes = false;
    }
    if (sDetail.Picked === "") {
      setErrorMsg((obj) => ({ ...obj, Picked: "Picked is Empty" }));
      iRes = false;
    }
    if (sDetail.Balance === "") {
      setErrorMsg((obj) => ({ ...obj, Balance: "Balance is Empty" }));
      iRes = false;
    }
    if (sDetail.ItemCode === "") {
      setErrorMsg((obj) => ({ ...obj, ItemCode: "ItemCode is Empty" }));
    }
    if (sDetail.SrNo === "") {
      setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty" }));
      iRes = false;
    }
    if (sDetail.ItemName === "") {
      setErrorMsg((obj) => ({ ...obj, ItemName: "ItemName is Empty" }));
      iRes = false;
    }
    if (sDetail.Qty === "") {
      setErrorMsg((obj) => ({ ...obj, Qty: "Quantity is Empty" }));
      iRes = false;
    } else if (sDetail.Qty <= 0) {
      setErrorMsg((obj) => ({ ...obj, Qty: "Quantity shouldn't be zero." }));
      iRes = false;
    }
    // else if (sDetail.Qty > sDetail.Stock) {
    //     setErrorMsg((obj) => ({ ...obj, Qty: "Quantity shouldn't be greater then stock.", }));
    //     iRes = false;
    // }
    if (sDetail.Unit === "") {
      setErrorMsg((obj) => ({ ...obj, Unit: "unit is Empty" }));
      iRes = false;
    }
    if (sDetail.BaseQty === "") {
      setErrorMsg((obj) => ({ ...obj, BaseQty: "BaseQty is Empty" }));
      iRes = false;
    }
    if (sDetail.Stock === "") {
      setErrorMsg((obj) => ({ ...obj, Stock: "stock is Empty" }));
      iRes = false;
    }
    //  else if (sDetail.Stock === 0) {
    //     setErrorMsg((obj) => ({ ...obj, Stock: "stock is zero.", }));
    //     iRes = false;
    // }
    if (sDetail.PackQty === "") {
      setErrorMsg((obj) => ({ ...obj, PackQty: "packQty is Empty" }));
      iRes = false;
    }

    return iRes;
  };

  const fOnPresNew = () => {
    setUnitDataArr([]); //unit arr
    setDetail(vInitialstate);
    GetInstantPickingLineItems(); //grid
    setErrorMsg({
      SrNo: "",
      ItemCode: "",
      ItemName: "",
      Barcode: "",
      CardId: "",
      Qty: "",
      BaseQty: "",
      Invoiced: "",
      Picked: "",
      Balance: "",
      Unit: "",
      PackQty: "",
      Stock: "",
    });
    document.getElementById("Barcode")?.focus();
  };
  let timeout = null;
  const fSave = () => {
    setErrorMsg(vInitError);
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (setValidation()) {
        GetInstantPickingUpdate();
      }
    }, 800);
  };
  const fDelete = () => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            GetInstantPickingDelete();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => console.log("no"),
        },
      ],
    });
    // if (window.confirm('Are you sure you want to Delete?') == true) {

    // }
  };

  const fPost = () => {
    GetInstantPickingPosting();
  };
  const fVariance = () => {
    GetInstantPickingVariance();
    fOpenInstantPickingVarianceModel();
  };
  const fGridRowData = async (e) => {
    if (sDetail.Status === "Pending" || sDetail.Status === "Progress") {
      setDetail((obj) => ({
        ...obj,
        SrNo: e.row.SrNo,
        ItemCode: e.row.ItemCode,
        ItemName: e.row.ItemName,
        Barcode: e.row.Barcode,
        CardId: e.row.CardId,
        Qty: e.row.Qty,
        BaseQty: e.row.BaseQty,
        // Invoiced: e.row.Invoiced,
        // Picked: e.row.Picked,
        //  Balance:e.row.Balance,
        // Unit: e.row.UnitCode,
        //  PackQty:e.row.PackQty,
        //  Stock:e.row.Stock,
      }));
      GetGridBarcodeDetail(e.row.Barcode, e.row.SrNo);
    } else if (sDetail.Status === "Completed") {
      setDetail((obj) => ({
        ...obj,
        SrNo: e.row.SrNo,
        ItemCode: e.row.ItemCode,
        ItemName: e.row.ItemName,
        Barcode: e.row.Barcode,
        CardId: e.row.CardId,
        Qty: e.row.Qty,
        BaseQty: e.row.BaseQty,
        Invoiced: 0,
        Picked: 0,
        Balance: 0,
        Unit: "",
        Stock: 0,
      }));
    }
    let itemCdInfo = await GetItemCdDetail(e.row.ItemCode);
    if (itemCdInfo.Type == "SUCCESS") {
      if (itemCdInfo.ResultSet.length > 0) {
        let currObj = itemCdInfo.ResultSet.find((obj) => {
          return obj.Unit == e.row.UnitCode;
        });
        setDetail((obj) => ({
          ...obj,
          Unit: currObj.Unit,
          PackQty: currObj.PackQty,
        }));
      }
    }
  };

  //api call

  const GetInstantPickingPosting = async () => {
    let vInstantPickingPostingObj = {
      v_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_VocNo: vRdxInstantPickingDetail.VocNo,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vInstantPickingPosting = await fExecuteAPI(
      "INSTANCE_PICKING_POST_GETROW",
      vInstantPickingPostingObj
    );
    if (vInstantPickingPosting.Type == "SUCCESS") {
      fAlertToast("SUCCESS", "Posted Successfully");
      setDetail((obj) => ({ ...obj, Status: "Completed" }));
      dispatch(InstantPickingHead_Status_Set({ Status: "Completed" }));
      fOnPresNew();
    } else {
      fAlertToast("FAILED", vInstantPickingPosting.Message);
    }
  };

  const GetInstantPickingVariance = async () => {
    let vInstantPickingVarianceObj = {
      v_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_VocNo: vRdxInstantPickingDetail.VocNo,
    };
    const vInstantPickingVariance = await fExecuteAPI(
      "INSTANCE_PICKING_POST_VARIANCE_GETROW",
      vInstantPickingVarianceObj
    );
    if (vInstantPickingVariance.Type?.toUpperCase() === "SUCCESS") {
      setVarianceList(vInstantPickingVariance.ResultSet);
    } else {
      fAlertToast("FAILED", vInstantPickingVariance.Message);
    }
  };

  const GetInstantPickingDelete = async () => {
    let vInstantPickingDeleteObj = {
      v_PKD_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_PKD_VocNo: vRdxInstantPickingDetail.VocNo,
      v_PKD_SrNo: sDetail.SrNo,
    };
    const vInstantPickingDelete = await fExecuteAPI(
      "INSTANCE_PICKING_DELETE_GETROW",
      vInstantPickingDeleteObj
    );
    if (vInstantPickingDelete.Type?.toUpperCase() === "SUCCESS") {
      GetInstantPickingLineItems();
      fAlertToast("SUCCESS", "Successfully deleted");
      fOnPresNew();
    } else {
      fAlertToast("FAILED", vInstantPickingDelete.Message);
    }
    fOnPresNew();
  };

  const GetCartBarcodeDetail = async () => {
    const CartBarcodeDetailObj = {
      v_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_VocNo: vRdxInstantPickingDetail.VocNo,
      v_SrNo: sDetail.SrNo,
      v_Barcode: sDetail.Barcode,
      v_BinCd: vRdxInstantPickingDetail.BinCode,
      v_Loc: vRdxInstantPickingDetail.Loc,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "INSTANCE_PICKING_BARCODE_ITEM_SEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setDetail((obj) => ({
          ...obj,
          ItemCode: CartBarcodeDetail.ResultSet[0].ItmCd,
          ItemName: CartBarcodeDetail.ResultSet[0].Name2,
        }));
        setDetail((obj) => ({
          ...obj,
          CardId: CartBarcodeDetail.ResultSet[0].CardID,
        }));
        setDetail((obj) => ({
          ...obj,
          Invoiced: CartBarcodeDetail.ResultSet[0].InvoicedQty,
          Picked: CartBarcodeDetail.ResultSet[0].PickedQty,
        }));
        if (CartBarcodeDetail.ResultSet[0].ItmCd !== "") {
          let itemCdInfo = await GetItemCdDetail(
            CartBarcodeDetail.ResultSet[0].ItmCd
          );
          if (itemCdInfo.Type == "SUCCESS") {
            setUnitDataArr(itemCdInfo.ResultSet);
            if (itemCdInfo.ResultSet.length > 0) {
              setDetail((obj) => ({
                ...obj,
                Unit: itemCdInfo.ResultSet[0].Unit,
                PackQty: itemCdInfo.ResultSet[0].PackQty,
              }));
            }
          }
        }
        document.getElementById("Qty")?.focus();
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          CardId: "",
          Unit: "",
          Invoiced: "",
          Picked: "",
          Barcode: "",
        }));
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (CartBarcodeDetail.Type === "FAILED") {
      setDetail((obj) => ({ ...obj, cardId: "" }));
      fAlertToast("FAILED", CartBarcodeDetail.Message);
    }
  };

  const GetGridBarcodeDetail = async (Barcode, SrNo) => {
    const CartBarcodeDetailObj = {
      v_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_VocNo: vRdxInstantPickingDetail.VocNo,
      v_SrNo: SrNo,
      v_Barcode: Barcode,
      v_BinCd: vRdxInstantPickingDetail.BinCode,
      v_Loc: vRdxInstantPickingDetail.Loc,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "INSTANCE_PICKING_BARCODE_ITEM_SEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        // setDetail((obj) => ({ ...obj, ItemCode: CartBarcodeDetail.ResultSet[0].ItmCd, ItemName: CartBarcodeDetail.ResultSet[0].Name2 }));
        // setDetail((obj) => ({ ...obj, CardId: CartBarcodeDetail.ResultSet[0].CardID }));
        setDetail((obj) => ({
          ...obj,
          Invoiced: CartBarcodeDetail.ResultSet[0].InvoicedQty,
          Picked: CartBarcodeDetail.ResultSet[0].PickedQty,
        }));
        // document.getElementById('Qty')?.focus()
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          CardId: "",
          Unit: "",
          Invoiced: "",
          Picked: "",
          Barcode: "",
        }));
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (CartBarcodeDetail.Type === "FAILED") {
      setDetail((obj) => ({ ...obj, cardId: "" }));
      fAlertToast("FAILED", CartBarcodeDetail.Message);
    }
  };

  const GetBinStock = async () => {
    let vBinStockTransOutObj = {
      v_DocTyp: vRdxInstantPickingDetail.VocTyp,
      v_DocNo: vRdxInstantPickingDetail.VocNo,
      v_SrNo: sDetail.SrNo,
      v_Loc: vRdxInstantPickingDetail.Loc,
      v_CardID: sDetail.CardId,
      v_BinCd: vRdxInstantPickingDetail.BinCode,
      v_Qty: fcovertToNumber(vRdxInstantPickingDetail.Qty),
    };

    if (
      sDetail.ItemCode !== "" &&
      sDetail.CardId !== "" &&
      vRdxInstantPickingDetail.BinCode !== ""
    ) {
      const vBinStockTransOut = await fExecuteAPI(
        "GET_API_BIN_STOCK_TRANSOUT",
        vBinStockTransOutObj
      );
      if (vBinStockTransOut.ResultSet.length > 0) {
        setBinStock(vBinStockTransOut.ResultSet[0].StkQty);
      } else if (vBinStockTransOut.Type == "FAILED") {
        fAlertToast("FAILED", vBinStockTransOut.Message);
      }
    } else if (
      sDetail.ItemCode === "" ||
      sDetail.CardId === "" ||
      vRdxInstantPickingDetail.BinCode !== ""
    ) {
      setBinStock(0);
    }
  };

  const GetItemCdDetail = async (xItemCode) => {
    const itemCdInfo = await fExecuteAPI(
      "ITEM_UNIT_INSTANTPICKING_GETROW",
      xItemCode
      // sDetail.ItemCode
    );
    if (itemCdInfo.Type == "SUCCESS") {
      if (itemCdInfo.ResultSet.length > 0) {
        setUnitDataArr(itemCdInfo.ResultSet);
        return itemCdInfo;
      }
    } else if (itemCdInfo.Type == "FAILED") {
      fAlertToast("FAILED", itemCdInfo.Message);
      return itemCdInfo;
    }
  };

  const GetInstantPickingUpdate = async () => {
    setLoading(true);
    let vInstantPickingUpdateObj = {
      v_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_VocNo: vRdxInstantPickingDetail.VocNo,
      v_SrNo: sDetail.SrNo,
      v_BinCd: vRdxInstantPickingDetail.BinCode,
      v_Barcode: sDetail.Barcode,
      v_CardID: sDetail.CardId,
      v_ItmCd: sDetail.ItemCode,
      v_Qty: sDetail.Qty,
      v_Unit: sDetail.Unit,
      v_BaseQty: sDetail.BaseQty,
      v_UserCd: vRdxuserInfo.UserID,
      v_BinName: vRdxInstantPickingDetail.BinName,
      v_Loc: vRdxInstantPickingDetail.Loc,
    };
    const vInstantPickingUpdate = await fExecuteAPI(
      "INSTANCE_PICKING_PKD_UPDATE_GETROW",
      vInstantPickingUpdateObj
    );
    if (vInstantPickingUpdate.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      GetInstantPickingLineItems();
      fOnPresNew();
    } else {
      fAlertToast("FAILED", vInstantPickingUpdate.Message);
    }
    setLoading(false);
  };

  const GetInstantPickingLineItems = async () => {
    setLoading(true);
    let vInstantPickingLineItemsObj = {
      v_PKD_VocTyp: vRdxInstantPickingDetail.VocTyp,
      v_PKD_VocNo: vRdxInstantPickingDetail.VocNo,
    };
    const vInstantPickingLineItems = await fExecuteAPI(
      "INSTANCE_PICKING_DETAIL_LIST_GETROW",
      vInstantPickingLineItemsObj
    );
    if (vInstantPickingLineItems.Type?.toUpperCase() === "SUCCESS") {
      if (vInstantPickingLineItems.ResultSet.length > 0) {
        setInputGridData(vInstantPickingLineItems.ResultSet);
      } else {
        setInputGridData([]);
      }
    } else if (vInstantPickingLineItems.Type === "FAILED") {
      fAlertToast("FAILED", vInstantPickingLineItems.Message);
    }
    setLoading(false);
  };
  const fUnitItem = async () => {
    let itemCdInfo = await GetItemCdDetail(sDetail.ItemCode);
    if (itemCdInfo.Type == "SUCCESS") {
      if (itemCdInfo.ResultSet.length > 0) {
        setDetail((obj) => ({
          ...obj,
          Unit: itemCdInfo.ResultSet[0].Unit,
          PackQty: itemCdInfo.ResultSet[0].PackQty,
        }));
      }
    }
  };

  useEffect(() => {
    GetInstantPickingLineItems();
  }, []);

  useEffect(() => {
    setDetail((obj) => ({
      ...obj,
      Balance: fcovertToNumber(sDetail.Invoiced - sDetail.Picked),
    }));
  }, [sDetail.Invoiced, sDetail.Picked]);

  // useEffect(() => {
  //     if (sDetail.ItemCode !== "") {
  //         fUnitItem();
  //     }
  // }, [sDetail.ItemCode]);

  useEffect(() => {
    if (
      sDetail.ItemCode !== "" &&
      sDetail.CardId !== "" &&
      vRdxInstantPickingDetail.BinCode !== "" &&
      vRdxInstantPickingDetail.Status !== "Completed"
    ) {
      GetBinStock();
    } else if (
      sDetail.ItemCode === "" ||
      sDetail.CardId === "" ||
      vRdxInstantPickingDetail.BinCode === ""
    ) {
      setBinStock(0);
    }
  }, [sDetail.ItemCode, sDetail.CardId, vRdxInstantPickingDetail.BinCode]);

  useEffect(() => {
    setDetail((obj) => ({
      ...obj,
      BaseQty: fcovertToNumber(sDetail.Qty * sDetail.PackQty),
    }));
  }, [sDetail.Qty, sDetail.PackQty]);

  useEffect(() => {
    if (
      sDetail.ItemCode !== "" &&
      sDetail.CardId !== "" &&
      vRdxInstantPickingDetail.BinCode !== ""
    ) {
      let vStockCal = sDetail.PackQty == 0 ? 0 : sBinStock / sDetail.PackQty;
      setDetail((obj) => ({ ...obj, Stock: fcovertToNumber(vStockCal) }));
    } else {
      setBinStock(0);
      setDetail((obj) => ({ ...obj, Stock: 0 }));
    }
  }, [sDetail.PackQty, sBinStock]);

  useEffect(() => {
    BarcodeFocusOnLoad.current?.focus();
  }, []);

  const [sVarianceColumns, setVarianceColumns] = useState([]);
  const [scolumns, setcolumns] = useState([]);

  useEffect(() => {
    GetGitterColumns(setcolumns, "INSTANTPICKING_DETAIL", columns);
    GetGitterColumns(
      setVarianceColumns,
      "INSTANTPICKING_VARIANCE",
      VarianceColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid py-2 ">
      <div className="Breadcrumbs">
        <InstantPicking_Breadcrumbs />
      </div>
      <div className="Instantg-picking-detail">
        <Box sx={{ flexGrow: 1 }} className="xs-instant-picking-detail-label">
          <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.Type</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Type"}
                    xVariant={"standard"}
                    xValue={vRdxInstantPickingDetail.VocTyp}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTyp"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Name"}
                    xVariant={"standard"}
                    xValue={vRdxInstantPickingDetail.VocTypName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTypName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 2, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.No</label>
                </Grid>
                <Grid item xs={10}>
                  <CmpTextField
                    xLabelText={"Doc.No"}
                    xVariant={"standard"}
                    xValue={vRdxInstantPickingDetail.VocNo}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocNo"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Bin</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Bin Code"}
                    xVariant={"standard"}
                    xValue={vRdxInstantPickingDetail.BinCode}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BinCode"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Bin Name"}
                    xVariant={"standard"}
                    xValue={vRdxInstantPickingDetail.BinName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BinName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 2, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Status</label>
                </Grid>
                <Grid item xs={10}>
                  <CmpTextField
                    xLabelText={"Status"}
                    xVariant={"standard"}
                    xValue={sDetail.Status}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Status"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <div className="container-fluid mt-3">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Sr.No"}
                  xVariant={"outlined"}
                  xValue={sDetail.SrNo}
                  xOnChange={""}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"SrNo"}
                  xError={sErrorMsg.SrNo === "" ? false : true}
                  xErrorMessage={sErrorMsg.SrNo}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={4}>
                <CmpTextFieldEnter
                  xref={BarcodeFocusOnLoad}
                  xLabelText={"Bar Code"}
                  xVariant={"outlined"}
                  xValue={sDetail.Barcode}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={false}
                  xType={"number"}
                  xName={"Barcode"}
                  xOnKeyUp={(e) => {
                    fCardIdKey(e);
                  }}
                  xError={sErrorMsg.Barcode === "" ? false : true}
                  xErrorMessage={sErrorMsg.Barcode}
                  xOnEnter={(e) => {
                    fCardIdKey(sEnterKeyObj);
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Card ID"}
                  xVariant={"outlined"}
                  xValue={sDetail.CardId}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"CardId"}
                  xError={sErrorMsg.CardId === "" ? false : true}
                  xErrorMessage={sErrorMsg.CardId}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Item Code"}
                  xVariant={"outlined"}
                  xValue={sDetail.ItemCode}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"text"}
                  xName={"ItemCode"}
                  xError={sErrorMsg.ItemCode === "" ? false : true}
                  xErrorMessage={sErrorMsg.ItemCode}
                />
              </Grid>
              <Grid item xs={6} sm={8} md={8}>
                <CmpTextField
                  xLabelText={"Item Name"}
                  xVariant={"outlined"}
                  xValue={sDetail.ItemName}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"text"}
                  xName={"ItemName"}
                  xError={sErrorMsg.ItemName === "" ? false : true}
                  xErrorMessage={sErrorMsg.ItemName}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Invoiced"}
                  xVariant={"outlined"}
                  xValue={sDetail.Invoiced}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"Invoiced"}
                  xError={sErrorMsg.Invoiced === "" ? false : true}
                  xErrorMessage={sErrorMsg.Invoiced}
                />
              </Grid>
              <Grid item xs={4} sm={8} md={8}>
                <CmpTextField
                  xLabelText={"Picked"}
                  xVariant={"outlined"}
                  xValue={sDetail.Picked}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"text"}
                  xName={"binName"}
                  xError={sErrorMsg.Picked === "" ? false : true}
                  xErrorMessage={sErrorMsg.Picked}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Balance"}
                  xVariant={"outlined"}
                  xValue={sDetail.Balance}
                  xOnChange={""}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"Balance"}
                  xError={sErrorMsg.Balance === "" ? false : true}
                  xErrorMessage={sErrorMsg.Balance}
                />
              </Grid>
              <Grid item xs={4} sm={8} md={8}>
                <CmpTextField
                  xLabelText={"Qty"}
                  xVariant={"outlined"}
                  xValue={sDetail.Qty}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={false}
                  xType={"number"}
                  xName={"Qty"}
                  xOnKeyUp={(e) => {
                    fQtyKey(e);
                  }}
                  xError={sErrorMsg.Qty === "" ? false : true}
                  xErrorMessage={sErrorMsg.Qty}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <CmpSelectBox
                  xLabelText="Unit"
                  xValue={sDetail.Unit}
                  xOnChange={(event) => fUnitSelect(event)}
                  xName={"Unit"}
                  xData={sUnitData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.Unit === "" ? false : true}
                  xErrorMessage={sErrorMsg.Unit}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={4} sm={8} md={8}>
                <CmpTextField
                  xLabelText={"Base Qty"}
                  xVariant={"outlined"}
                  xValue={sDetail.BaseQty}
                  xOnChange={""}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"BaseQty"}
                  xError={sErrorMsg.BaseQty === "" ? false : true}
                  xErrorMessage={sErrorMsg.BaseQty}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Stock"}
                  xVariant={"outlined"}
                  xValue={sDetail.Stock}
                  xOnChange={(event) => fOnChangeInstantPickingDetail(event)}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"Stock"}
                  xError={sErrorMsg.Stock === "" ? false : true}
                  xErrorMessage={sErrorMsg.Stock}
                />
              </Grid>
            </Grid>
          </Box>
          <br></br>
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 6, sm: 12, md: 10 }}
              className="text-center"
            >
              <Grid item xs={2}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={fOnPresNew}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
              <Grid item xs={2}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={vRdxInstantPickingDetail.Status === "Completed"}
                />
              </Grid>
              <Grid item xs={2}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={fDelete}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={vRdxInstantPickingDetail.Status === "Completed"}
                />
              </Grid>

              <Grid item xs={2}>
                <CmpButton
                  xbtnName="Post"
                  xOnClick={fPost}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={vRdxInstantPickingDetail.Status === "Completed"}
                />
              </Grid>
              <Grid item xs={2} className=" btn-instant-picking-Detail">
                <CmpButton
                  xbtnName="Detail"
                  xOnClick={fOpenInstantPickingModel}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={false}
                />
              </Grid>
              <Grid item xs={2}>
                <CmpButton
                  xbtnName="Variance"
                  xOnClick={fVariance}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </Box>

          <br></br>
          <div className="xs-instant-picking-detail-grid">
            <Box sx={{ height: "30vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.id}
                rows={itemRows}
                columns={scolumns}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                experimentalFeatures={{ newEditingApi: false }}
                hideFooter={itemRows.length < 100}
                onRowClick={fGridRowData}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </Box>
          </div>
        </div>
      </div>
      <Modal
        open={sOpenInstantPickingModel}
        onClose={fCloseInstantPickingModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
        <GCTitleSticky title={'Grid'} onClose={fCloseInstantPickingModel} />
         
         
          <div>
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseInstantPickingModel} />
            </div> */}
            <div className="py-2">
              {sLoading ? (
                <div
                  style={{
                    height: "22rem",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Box style={{ height: "70vh", width: "100%" }}>
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    height={20}
                    getRowId={(row) => row.id}
                    rows={itemRows}
                    columns={scolumns}
                    // pageSize={5}
                    // rowsPerPageOptions={[5]}
                    experimentalFeatures={{ newEditingApi: false }}
                    hideFooter={itemRows.length < 100}
                    onRowClick={fGridRowData}
                    onRowDoubleClick={fonDoubleClickCloseGrid}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </Box>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={sOpenInstantPickingPostVarianceModel}
        onClose={fCloseInstantPickingVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
        <GCTitleSticky title={'Variance'} onClose={fCloseInstantPickingVarianceModel} />
       
           
          <div>
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseInstantPickingVarianceModel} />
            </div> */}
            <div className="py-2">
              {sLoading ? (
                <div
                  style={{
                    height: "22rem",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Box style={{ height: "70vh", width: "100%" }}>
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    getRowId={(row) => row.id}
                    rows={vVarianceRows}
                    columns={sVarianceColumns}
                    // pageSize={5}
                    // rowsPerPageOptions={[5]}
                    experimentalFeatures={{ newEditingApi: false }}
                    hideFooter={vVarianceRows.length < 100}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </Box>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
